/**
 * Unauthorized Error when 401
 */
export default class UnauthorizedError extends Error {
    /**
     * @param {string} description description
     */
    constructor(description) {
        super(description)
        this.name = this.constructor.name
    }
}
